import React, { useEffect } from 'react';
import PageCarousel from '../components/PageCarousel';

function CallForWorkshops() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const workshopTopics = [
    'Applications of Transformers in vision, medical imaging or other related areas',
    'Applications of Generative modeling using diffusion models',
    'Applications of Deep Reinforcement techniques for various vision and image-related works.'
  ];

  const proposalRequirements = [
    'Title of the workshop',
    'Workshop Organizers (names, affiliation, and contact information)',
    'Scope and topics of the workshop (max 1 page)',
    'Planned format of the workshop, including a tentative schedule',
    'Plenary Speaker Info: Mention name/affiliation if the duration extends to 4 hours.'
  ];

  const importantDates = [
    { event: "Workshop Proposal Submission Starts", date: "March 2, 2026" },
    { event: "Workshop Proposal Submission Deadline", date: "March 31, 2026" },
    { event: "Notification of Accepted Workshops", date: "April 15, 2026" },
    { event: "Call for Paper Submission", date: "April 17, 2026" },
    { event: "Paper Submission Deadline", date: "May 15, 2026" },
    { event: "Paper Acceptance Notification", date: "June 15, 2026" },
    { event: "Registration for Workshop", date: "June 15 – July 01, 2026" }
  ];

  return (
    <div className="page-container">
      <PageCarousel />
      
      <section className="section-padding bg-white">
        <div className="container">
          
          {/* 1. Header Section */}
          <div className="row mb-5">
            <div className="col-12 text-center">
              <h1 className="section-title" style={{ fontWeight: 700, color: '#111' }}>Call for Workshops</h1>
              <div style={{ width: '80px', height: '4px', background: '#70b60a', margin: '15px auto' }}></div>
              <p className="col-lg-10 mx-auto mt-4 text-muted" style={{ lineHeight: '1.8', textAlign: 'justify' }}>
                The NCVPRIPG 2026 workshops will highlight current topics related to technical and business issues in computer vision, pattern recognition, and image processing. We invite proposals for 3-hour-long workshops (extendable to 4 hours with a plenary speaker).
              </p>
            </div>
          </div>

          {/* 2. Topics of Interest */}
          <div className="row mb-5">
            <div className="col-lg-10 mx-auto">
              <h3 className="mb-4" style={{ borderLeft: '5px solid #70b60a', paddingLeft: '15px', fontWeight: 600 }}>Suggested Topics</h3>
              <div className="p-4 bg-light rounded shadow-sm">
                {workshopTopics.map((topic, idx) => (
                  <div key={idx} className="d-flex align-items-start mb-3">
                    <i className="lni-chevron-right text-success mt-1 mr-3" style={{ fontWeight: 'bold' }}></i>&nbsp;
                    <span style={{ fontSize: '16px', color: '#333' }}>{topic}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* 3. Combined Event Note */}
          <div className="row mb-5">
            <div className="col-lg-10 mx-auto">
              <div className="alert alert-warning border-0 shadow-sm" style={{ borderRadius: '10px' }}>
                <i className="lni-warning mr-2"></i>&nbsp;
                <strong>Note:</strong> It is possible to propose a combined <strong>Workshop + Challenge</strong> (within the 3-hour limit). Please refer to the challenge guidelines and mention this configuration in your proposal.
              </div>
            </div>
          </div>

          {/* 4. Proposal Format Card */}
          <div className="row mb-5">
            <div className="col-lg-10 mx-auto">
              <div className="p-4 border rounded shadow-sm bg-white">
                <h3 className="mb-4" style={{ color: '#70b60a', fontWeight: 600, fontSize: '22px' }}>
                   Workshop Proposal Format (PDF)
                </h3>
                <p className="text-muted small mb-4 italic">Each proposal must follow this order:</p>
                <div className="row">
                  {proposalRequirements.map((item, idx) => (
                    <div key={idx} className="col-12 d-flex align-items-start mb-3">
                      <i className="lni-check-mark-circle text-success mt-1 mr-3"></i>&nbsp;
                      <span style={{ fontSize: '16px', color: '#444' }}>{item}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* 5. Submission Section */}
          <div className="row mb-5">
            <div className="col-lg-10 mx-auto text-center">
              <div className="p-4 rounded border-0 shadow-sm" style={{ background: '#eef7ff' }}>
                <h5 className="font-weight-bold mb-3" style={{ color: '#0056b3' }}>Proposal Submission</h5>
                <p className="mb-2">Email your proposal PDF to:</p>
                <div className="d-flex justify-content-center align-items-center">
                  <i className="lni-envelope mr-2 text-primary"></i>&nbsp;
                  <a href="mailto:ankit.jha@lnmiit.ac.in" className="h5 mb-0 text-primary font-weight-bold">ankit.jha@lnmiit.ac.in</a>
                </div>
                <p className="mt-4 small text-muted">
                  * All abstracts/presentations will be archived online. No publisher proceedings are planned for workshops.
                </p>
              </div>
            </div>
          </div>

          {/* 6. Timeline Section (Bottom) */}
          <div className="row mt-5">
            <div className="col-lg-10 mx-auto">
              <h3 className="mb-4" style={{ borderLeft: '5px solid #70b60a', paddingLeft: '15px', fontWeight: 600 }}>Workshop Timeline</h3>
              <div className="table-responsive shadow-lg rounded" style={{ overflow: 'hidden' }}>
                <table className="table table-hover mb-0">
                  <thead style={{ background: '#70b60a', color: '#fff' }}>
                    <tr>
                      <th style={{ padding: '18px 25px', fontSize: '16px' }}>Event</th>
                      <th style={{ padding: '18px 25px', fontSize: '16px' }}>Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {importantDates.map((item, idx) => (
                      <tr key={idx}>
                        <td style={{ padding: '15px 25px', fontWeight: '500' }}>{item.event}</td>
                        <td style={{ padding: '15px 25px', color: '#70b60a', fontWeight: '700' }}>{item.date}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>

        </div>
      </section>
    </div>
  );
}

export default CallForWorkshops;